import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import LandingPage    from './components/LandingPage';
import ResetPassword  from './components/ResetPassword';
import CompleteProfile from './components/CompleteProfile';
import Navbar         from './components/Navbar';
import Footer         from './components/Footer';

import HomePage       from './pages/HomePage';
import VisionPage     from './pages/VisionPage';
import FleetPage      from './pages/FleetPage';
import PricingPage    from './pages/PricingPage';
import TechnologyPage from './pages/TechnologyPage';
import EcosystemPage  from './pages/EcosystemPage';
import ContactPage    from './pages/ContactPage';
import AccountPage    from './pages/AccountPage';
import AboutPage      from './pages/AboutPage';

function AppInner() {
  const { session, user, loading, recovery } = useAuth();

  if (loading) {
    return (
      <div className="app-splash">
        <img src="/axion-logo.png" alt="Axion Mobility" className="app-splash-logo" />
      </div>
    );
  }

  // User clicked a password-reset link — let them set a new password.
  if (recovery) return <ResetPassword />;

  // Not signed in — show the (locked) landing page. Session drives the gate,
  // so onLogin is a no-op; AuthContext re-renders this on auth change.
  if (!session) return <LandingPage onLogin={() => {}} />;

  // Signed in but setup never finished (e.g. arrived via magic link) —
  // force them to set name + password before entering the app.
  if (session && user && !user.user_metadata?.profile_complete) {
    return <CompleteProfile />;
  }

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/"           element={<HomePage />} />
        <Route path="/vision"     element={<VisionPage />} />
        <Route path="/fleet"      element={<FleetPage />} />
        <Route path="/pricing"    element={<PricingPage />} />
        <Route path="/technology" element={<TechnologyPage />} />
        <Route path="/ecosystem"  element={<EcosystemPage />} />
        <Route path="/contact"    element={<ContactPage />} />
        <Route path="/account"    element={<AccountPage />} />
        <Route path="/about"      element={<AboutPage />} />
        <Route path="*"           element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}

export default App;
